



































import { defineComponent } from "@vue/composition-api";
import { isEmpty } from "lodash-es";
import { PaymentPackageEnum, PaymentPackage, CurrencyCost } from "@teacherskaya/api-provider/dist/api/PaymentPackageProvider";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";
import { $t } from "@/lib/helpers/i18nHelper";
import { formatMoney, getCurrencySymbol } from "@/lib/helpers/money";
import { FormFields, FormValues, Dictionary } from "@/types";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import BaseFlexForm from "@/components/BaseFlexForm.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import fields from "./config";

export default defineComponent({
  name: "PaymentPackageEditForm",
  components: { BlockBaseForm, ModalConfirm, BaseFlexForm },
  props: {
    paymentPackage: { type: Object as () => PaymentPackage | undefined },
    currencyList: { type: Array as () => Currency[], required: true },
    hideCosts: { type: Boolean, default: false },
    buttonsText: { type: Object as () => Dictionary<string>, default: () => ({}) },
  },
  data() {
    return {
      validForm: true,
      fieldsErrors: {} as Dictionary<string[]>,
      formValues: {} as FormValues,
      showConfirm: false,
      currencyValuesState: {} as FormValues,
    };
  },
  computed: {
    formButtonsText(): { save: string; cancel: string } {
      return {
        save: $t("save"),
        cancel: $t("cancel"),
        ...this.buttonsText,
      };
    },
    deleteMessage(): string {
      if (this.paymentPackage) {
        // TODO: Remove this switch_case, should be text from config.
        switch (this.paymentPackage.type) {
          case PaymentPackageEnum.DEPOSIT:
            return $t("{group} {price} {name} deposit price delete message", [
              $t("Deposit Amount"),
              formatMoney(this.paymentPackage.amount),
              this.paymentPackage.name,
            ]);
          case PaymentPackageEnum.FILESET:
            return $t("{group} {price} {name} post price delete message", [
              $t("Post Price"),
              formatMoney(this.paymentPackage.amount),
              this.paymentPackage.name,
            ]);
          case PaymentPackageEnum.PER_SENT_MESSAGE:
            return $t("{group} {price} {name} messages price delete message", [
              $t("Per Message Price"),
              formatMoney(this.paymentPackage.amount),
              this.paymentPackage.name,
            ]);
          case PaymentPackageEnum.PER_MINUTE_MESSAGE:
            return $t("{group} {price} {name} messages price delete message", [
              $t("Per Minute Price"),
              formatMoney(this.paymentPackage.amount),
              this.paymentPackage.name,
            ]);
          default:
            return $t("Are you sure want to {0} {1}?", [$t("delete"), $t(this.paymentPackage.name)]);
        }
      } else return "";
    },
    currencyValues: {
      get(): FormValues {
        if (isEmpty(this.currencyValuesState) && this.paymentPackage && this.paymentPackage.costs.length > 0) {
          this.currencyValues = this.currencyFields.reduce((out, item) => {
            out[item.name] = item.value;
            return out;
          }, {} as FormValues);
        }
        return this.currencyValuesState;
      },
      set(v: FormValues) {
        this.currencyValuesState = v;
      },
    },
    calculateText(): string {
      return Object.keys(this.currencyValues).length > 0 ? $t("Recalculate") : $t("Calculate");
    },
    currencyFields(): FormFields {
      return this.currencyList.reduce((out, item) => {
        let value = this.paymentPackage && this.paymentPackage.costs.find(i => i.currency === item.name);
        out.push({
          name: item.name,
          title: $t("Cost, {0}", [$t(getCurrencySymbol(item.name))]),
          value: value && value.cost,
        });
        return out;
      }, [] as FormFields);
    },
    valid(): boolean {
      let noErrors = true;
      Object.keys(this.fieldsErrors).forEach(key => {
        if (this.fieldsErrors[key].length > 0) noErrors = false;
      });
      return this.validForm && noErrors;
    },
    packageExists(): boolean {
      return !!this.paymentPackage;
    },
    fields(): FormFields {
      const values: FormValues = this.paymentPackage || {};
      return fields.reduce((out, item) => {
        const field = { ...item, value: values[item.name] || null };
        out.push(field);
        return out;
      }, [] as FormFields);
    },
  },
  methods: {
    calculateCurrency() {
      if (!this.formValues.amount) return;
      const amount = Number(this.formValues.amount) || 0;
      this.currencyValues = this.currencyList.reduce((out, item) => {
        out[item.name] = formatMoney(amount * item.rate, { withSymbol: false, currencyCode: item.name });
        return out;
      }, {} as FormValues);
    },
    validate(values: FormValues) {
      if (!values.amount) {
        this.$set(this.fieldsErrors, "amount", [$t("{0} is required", [$t("Amount")])]);
      } else {
        this.fieldsErrors = {};
      }
    },
    formInput(values: FormValues) {
      this.formValues = values;
      if (Object.keys(this.fieldsErrors).length !== 0) {
        this.fieldsErrors = {};
      }
    },
    save(values: FormValues, vm: any) {
      this.validate(values);
      if (!this.valid) return;
      values.costs = this.currencyList.reduce((out, item) => {
        let cost = Number(this.currencyValues[item.name]);
        if (this.currencyValues[item.name] !== "" && !isNaN(cost) && cost > 0) {
          out.push({
            cost,
            currency: item.name,
          });
        }
        return out;
      }, [] as CurrencyCost[]);
      this.$emit("save", values, vm);
      this.currencyValuesState = {};
    },
    cancel() {
      this.validForm = true;
      this.$emit("cancel");
    },
    deleteItem() {
      this.$emit("delete");
      this.showConfirm = false;
    },
  },
});
